import styles from './Header.module.scss';
import logo from 'logo.svg';
import { useNavigate } from 'react-router-dom';
import { AllRoutes } from 'constants/routes';

export const Header = () =>{

    const navigate = useNavigate()

    return <header className={styles.header}>
        <img onClick={()=>navigate(AllRoutes.home)} src={logo} className={styles.logo} alt="logo" />
        <div className={styles.contacts}>
            <a className={styles.tel} href='tel:692827473'>692 82 74 73</a>
            <p className={styles.address} >С/ Fraga 17, 3C &#183; 50003 ZARAGOZA </p>
        </div>
    </header>
}
